import React, { useContext } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import ActiveAdd from "./ActiveAdd";
import ArchiveAdd from "./ArchiveAdd";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const MyAdds = () => {
  const { theme } = useContext(ThemeContext);
  const location = useLocation();

  return (
    <div>
      <div
        className={`w-full px-2 md:px-6  ${
          theme === "dark" ? "bg-black text-white" : "bg-white"
        }`}
      >
        <div className="flex flex-row items-center">
          <Link to={"/user-dashboard/adds/active"}>
            <h2
              className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium text-gray-400 border-b-2   ${
                theme === "dark" ? "bg-black text-white" : "bg-white"
              }  ${
                location.pathname == "/user-dashboard/adds/active" &&
                "border-primarygreen"
              }`}
            >
              Active
            </h2>
          </Link>
          <Link to={"/user-dashboard/adds/archive"}>
            <h2
              className={`px-2 md:px-8 py-2 md:py-4 text-sm md:text-base font-medium  ${
                theme === "dark" ? "bg-black text-white" : "bg-white"
              } text-gray-400 border-b-2 ${
                location.pathname == "/user-dashboard/adds/archive" &&
                "border-primarygreen"
              }`}
            >
              Archive
            </h2>
          </Link>
        </div>
      </div>
      <div className="py-6 md:py-10 max-w-[95%] md:max-w-[95%] m-auto">
        <Routes>
          <Route path="/active" element={<ActiveAdd />} />
          <Route path="/archive" element={<ArchiveAdd />} />
        </Routes>
      </div>
    </div>
  );
};

export default MyAdds;
